// client/src/components/marketer/project/modals/ProcessingModal.js
import React from 'react';
import '../../../../styles/marketer/modals/ContractModals.css';

export default function ProcessingModal({ open }) {
  if (!open) return null;

  return (
    <div className="processing-modal mbm-overlay">
      <div className="processing-modal__content mbm">
        <div className="processing-modal__spinner-container">
          <div className="processing-modal__spinner" />
        </div>
        <div className="processing-modal__title">처리 중입니다...</div>
        <div className="processing-modal__message">계약금 납부 및 프로젝트 생성이 완료될 때까지 잠시만 기다려 주세요.</div>
      </div>
    </div>
  );
}